import saveToken from "../utils/saveToken";
import { DOMArray, getModalDOMRoot } from "../utils/dom";
import { API } from "../utils/API";
import { paramsToFormData } from "../utils/paramsToFormData";
class ShopifyAddToCart {
    scriptTarget;
    constructor(scriptTarget) {
        this.scriptTarget = scriptTarget;
    }
    extractVariantID = (variantQuery) => {
        return variantQuery.split("::")[1];
    };
    updateCartElement = (count, price) => {
        DOMArray(`span.cart span.count, span.cart-item-count-wrap`).forEach(element => {
            element.innerHTML = `${count} items`;
        });
        DOMArray(`span.cart span.price`).forEach(element => {
            element.innerHTML = '$' + price / 100;
        });
        DOMArray(`#CartCount, #cart-icon-bubble .cart-count-bubble, .header-cart__count--badge, span.cart-icon-wrapper__count, .cart-link__count,
                          span[class*=cart-item-count], div[class*=cart] span.n-item, span[class*=CartCount],
                          div.cart-item-count, span.cartCount, span.CartCount, span#cart-count,
                          span.js-cart-count,a.cart-count > span.cart-count-number, a.cart-count > span.bag-count,
                          div.mini-cart-wrap > span.item-count, span.cart_count, #cart_cnt, span.cart-count, #cartCount,
                          .cart-wrap .count, .cart-box .count, .cart_text > .number,span.header-cart-count,
                          badge badge--cart bigcounter, .top-cart .cart_num , .cart_container .cart_count,
                          .site-header__cart .icon__fallback-textt, .cartCountSelector,
                          div.tt-desctop-parent-cart span.tt-badge-cart, li.navUser-item--cart, span#cart-item-count, span.header__cart-count,
                          #CartToggleItemCount`)
            .forEach(element => {
            const dataCountElement = element.querySelector("[data-cart-count], [rv-text]");
            if (dataCountElement) {
                dataCountElement.innerText = String(count);
                element.classList.remove('hide');
                element.classList.remove('critical-hidden');
            }
            else {
                element.nodeValue = String(count);
                element.innerText = String(count);
            }
        });
        DOMArray('#cart-icon-bubble').forEach(element => {
            let badge = element.querySelector('.cart-count-bubble');
            if (!badge) {
                badge = document.createElement('div');
                badge.classList.add('cart-count-bubble');
                const badgeCount = document.createElement('span');
                badgeCount.innerText = String(count);
                badge.appendChild(badgeCount);
                element.appendChild(badge);
            }
        });
        DOMArray('#cart-count-view').forEach(element => {
            (element).style.display = "block";
        });
        DOMArray(".site-header__cart-indicator").forEach(element => {
            element.classList.remove("hide");
        });
        DOMArray('.cart-icon-wrapper.cart-icon-wrapper--has-items').forEach(element => {
            (element).style.display = "block";
        });
        DOMArray('.cart-icon-wrapper.cart-icon-wrapper--empty').forEach(element => {
            (element).style.display = "none";
        });
    };
    updateCustomThemeCart(cart) {
        let self = this;
        try { // Wokiee theme hack
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            addToCartHandler.addItem(cart.items[0]);
        }
        catch (e) {
            console.log();
        }
        try { // Parallax (Out of the Sandbox)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            refreshCart(cart);
            window.setTimeout(function () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                getModalDOMRoot(self.scriptTarget).querySelector(".cart-button").click();
            }, 500);
        }
        catch (e) {
            console.log();
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof timber !== "undefined" && typeof timber.RightDrawer !== "undefined") {
            try {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ajaxCart.load();
                window.setTimeout(function () {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    timber.RightDrawer.open();
                }, 2000);
            }
            catch (e) {
                console.log();
            }
        }
        //Boost Commerce Shop
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                Shopify.theme.jsAjaxCart.updateView();
            }
        }
        catch (e) {
            console.log();
        }
        //igelbeauty
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (typeof HsCartDrawer !== "undefined") {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                HsCartDrawer.updateSlideCart();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                HsCartDrawer.openCartDrawer(0, $);
            }
        }
        catch (e) {
            console.log();
        }
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            CartJS.getCart();
        }
        catch (e) {
            console.log();
        }
        //smarttalk.pt/
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Shopify.updateCartInfo(cart, '#cart-info #cart-content', 'shopping-cart');
        }
        catch (e) {
            console.log();
        }
        //klassyshop.com/
        try {
            document.dispatchEvent(new CustomEvent('cart:build'));
        }
        catch (e) {
            console.log();
        }
        //nipponpower.com
        try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
        catch (e) {
            console.log();
        }
    }
    async getCart() {
        return await API.get({
            url: '/cart.js',
        });
    }
    async addToCart(variantQuery, setStatus, variantID, quantity = 1, product) {
        try {
            setStatus('Adding');
            const id = variantID ?? this.extractVariantID(variantQuery);
            let externalProductProperties = {};
            try {
                externalProductProperties = window?.fsGetExternalProductProperties ? (await window.fsGetExternalProductProperties(product, id)) : {};
            }
            catch (e) {
                externalProductProperties = {};
            }
            let formData = paramsToFormData({
                id: id,
                quantity: quantity,
                ...externalProductProperties
            });
            if (window?.fsGetAddToCartLineItemCustomProperties && product) {
                let customProperties = null;
                try {
                    customProperties = window.fsGetAddToCartLineItemCustomProperties(product, id);
                }
                catch (e) {
                    customProperties = null;
                }
                if (customProperties) {
                    formData = JSON.stringify({ items: [
                            {
                                id: id,
                                quantity: quantity,
                                properties: customProperties
                            }
                        ] });
                }
            }
            const res = await API.post({
                url: "/cart/add.js",
                data: formData,
                config: {
                    headers: { "Content-Type": "multipart/form-data" }
                }
            });
            if (res.status === 200) {
                const cart = await this.getCart();
                if (cart.token) {
                    saveToken(cart.token);
                }
                this.updateCartElement(cart.item_count, cart.total_price);
                this.updateCustomThemeCart(cart);
                this.dispatchAddToCartResponse(cart);
                setStatus('Added');
            }
            else {
                this.dispatchAddToCartError(res);
                setStatus("Error", res.data.description);
            }
        }
        catch (e) {
            this.dispatchAddToCartError(e);
        }
    }
    dispatchAddToCartResponse = (cart) => {
        document.dispatchEvent(new CustomEvent('fs-custom-events-add-to-cart-response', { detail: { cart: cart } }));
    };
    dispatchAddToCartError = (res) => {
        document.dispatchEvent(new CustomEvent('fs-custom-events-add-to-cart-error-response', { detail: { res: res } }));
    };
}
export { ShopifyAddToCart };
//# sourceMappingURL=ShopifyAddToCart.js.map